import {
  rActiveDetailViewId,
  rActiveEditField,
  rApp,
  rPageBlocks,
  rSavedSpreadsheets,
} from "app/utils/recoil";
import { get, startCase } from "lodash";

import { Select } from "app/components";
import useSpreadsheetRequests from "app/useSpreadsheetRequests";
import useActiveBlock from "app/utils/useActiveBlock";
import { useRecoilValue } from "recoil";
import { typeIconMap } from "./DataSourceFields";
import { getRelationHeaders } from "./StaticFields";

const SpreadsheetColumnSelect = ({ data }) => {
  const { handleKanban } = useSpreadsheetRequests();

  const activeEditField = useRecoilValue(rActiveEditField);

  const refreshColumns = get(data, "refreshColumns", false);

  const activeBlock = useActiveBlock();

  const activeDetailViewId = useRecoilValue(rActiveDetailViewId);

  const app = useRecoilValue(rApp);

  const blocks = useRecoilValue(rPageBlocks);

  const activeDetailBlock = blocks.find((b) => b.id === activeDetailViewId);

  const currentBlock = activeBlock || activeDetailBlock;

  const savedSpreadsheets = useRecoilValue(rSavedSpreadsheets);

  const activeBlockSheet =
    get(data, "linkedSpreadsheet") ||
    savedSpreadsheets.find((s) => s.id === get(currentBlock, "spreadsheet"));

  let columns = get(activeBlockSheet, "headers", []);
  if (!columns.includes("frontly_id")) {
    columns = ["frontly_id", ...columns];
  }

  const sheetId = get(activeBlockSheet, "id");

  const fieldConfig = get(activeBlockSheet, ["field_data", "config"], {});

  const relatedHeaders = getRelationHeaders(
    activeBlockSheet,
    app,
    savedSpreadsheets,
    get(activeEditField, "id"),
    data.showOnlyRelationFields
  );

  const onChange = (val) => {
    if (refreshColumns) {
      handleKanban(sheetId, val);
    } else {
      data?.onChange(val);
    }
  };

  let options = [];

  if (columns.length === 0) {
    options = [{ label: "Select Column", value: null }];
  }

  // If showOnlyRelationFields is true, don't show the base columns
  if (columns.length > 0 && !data.showOnlyRelationFields) {
    options = columns.map((c) => ({ label: startCase(c), value: c }));
  }

  if (relatedHeaders.length > 0) {
    options = [
      ...options,
      ...relatedHeaders.map((c) => ({ label: startCase(c), value: c })),
    ];
  }

  const hideEmptyItem = get(data, "hideEmptyItem", true);

  return (
    <Select
      data={{
        ...data,
        placeholder: "Select Column",
        hideEmptyItem,
        showSearch: true,
        onChange: onChange,
        options: options.map((o) => {
          // Get type
          const key = o.value;
          let matchingType = get(fieldConfig, [key, "type"], "text");
          if (key === "frontly_id") {
            matchingType = "integer";
          }

          return {
            ...o,
            icon: get(typeIconMap, matchingType),
          };
        }),
      }}
    />
  );
};

export default SpreadsheetColumnSelect;
